import Vue from 'vue';
import Calendar from 'v-calendar/lib/components/calendar.umd';
Vue.component('Calendar', Calendar);
